import { useEffect, useRef, useState } from "react";
import useApi from "../../../../Utils/BackendClient";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";

const Reports = () => {

    const navigate = useNavigate();
    const toast = useRef();

    const { fetchReportList } = useApi();

    const [reports, setReports] = useState(null);

    useEffect(() => {
        const fetchData = async () => {

            const lazyState = {
                first: 0,
                rows: 10,
                page: 1,
            };

            const response = await fetchReportList(lazyState);

            if (response.status === 200) {
                setReports(response.data);
            }
            else {
                toast.current.show({ severity: "error", summary: "Помилка завантаження списку звітів", detail: "Помилка сервера " + response.status, life: 3000 });

                setReports([]);
            }
        }

        fetchData();

    }, [fetchReportList]);

    const NavigateToReport = (reportName, presentationName) => {
        navigate("/reports/reportdetails/", { state: { name: reportName, presentation: presentationName} });
    }

    return <div className="grid">
        {reports?.map(element => (<div className='col-12 md:col-6 lg:col-4' key={element.name}>
            <Card onClick={() => {NavigateToReport(element.name, element.value)}} style={{ cursor: 'pointer' }}>
                <div><h2>{element.value}</h2></div>
                <div>{element.description}</div>
            </Card>
        </div>))}
    </div>
}

export default Reports;